<template>
  <div class="w-full grid gap-1 content-start">
    <label v-if="labelText">{{ labelText }}</label>
    <v-text-field
      :id="id"
      class="focus-within:!border-primary-main border-2 items-center focus-within:outline outline-2 duration-200 bg-white p-3 pt-0 outline-primary-main/20 tl-input"
      :class="classObject"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      variant="plain"
      :disabled="disabled"
      :hide-details="true"
      :placeholder="placeholder"
      :density="size === 'small' ? 'compact' : 'compact'"
      :append-icon="type === 'password' ? (showPassword ? 'mdi-eye' : 'mdi-eye-off') : null"
      :type="type === 'password' ? (showPassword ? 'text' : 'password') : type"
      @click:append="togglePassword"
    ></v-text-field>
  </div>
</template>

<script lang="ts">
import type Vue from 'vue';
import { VTextField } from 'vuetify/components';

export default {
  extends: VTextField,
  props: {
    modelValue: String,
    customClass: String,
    labelText: { type: String, required: false },
    size: { type: String, default: 'medium' },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean },
    id: { type: String }
  },
  data() {
    return {
      showPassword: false
    };
  },
  mounted() {},
  computed: {
    classObject() {
      return {
        'rounded-2xl !text-xs': this.size === 'small',
        'rounded-lg': this.size === 'medium',
        [`${this.customClass}`]: !!this.customClass
      };
    }
  },
  // watch: {
  //   inputValue(newValue: string) {
  //     this.$emit('update:inputValue', newValue)
  //   }
  // },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    }
  }
} as Vue.ComponentOptions<any>;
</script>
